// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBlank__MdIEa6x1Kz {
  height: calc(0.89rem + 0.61rem);
}
`, "",{"version":3,"sources":["webpack://./src/components/TopBlank/index.module.less"],"names":[],"mappings":"AAEA;EACE,+BAAA;AADF","sourcesContent":["@import 'assets/styles/variables.less';\n\n.topBlank {\n  height: calc(@headerHeight + @headerTopHeight);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"topBlank": `topBlank__MdIEa6x1Kz`
};
export default ___CSS_LOADER_EXPORT___;
